import { useEffect } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { useCustomer } from "../contexts/CustomerContext";

export const useBookingAuthInterceptor = () => {
  const { isAuthenticated, requireLogin, token } = useCustomer();

  useEffect(() => {
    const interceptor = axios.interceptors.request.use(async (config) => {
      if (config.method !== "post" || config.url !== `${API}/bookings`) return config;
      let bookingToken = token;
      if (!isAuthenticated) {
        // Keep the original booking in memory until OTP succeeds or is cancelled.
        const session = await requireLogin();
        if (!session) throw new axios.Cancel("Booking login cancelled");
        bookingToken = session.token;
        const payload = typeof config.data === "string" ? JSON.parse(config.data) : config.data;
        config.data = {
          ...payload,
          phone: session.customer.phone.replace(/\D/g, "").slice(-10),
        };
      }
      config.headers.Authorization = `Bearer ${bookingToken}`;
      return config;
    });
    return () => axios.interceptors.request.eject(interceptor);
  }, [isAuthenticated, token, requireLogin]);
};

export default useBookingAuthInterceptor;
